"use client";

import { Icon, ospThemes } from "@ospweb/sdk-ui";

import React from "react";
import { cn } from "utils";

import { usePortfolioManage } from "@hooks/usePortfolioManage";

export interface PortfolioManageProps {
  id: string;
  iconClassname?: string;
  type?: "TOKEN" | "STOCK";
  zIndex?: number;
  portfolioId?: string;
  className?: string;
  /** 点击容器类名，用于控制点击区域的尺寸 */
  clickContainerClassName?: string;
}

/**
 * PortfolioManage组件
 * 基于 PortfolioContainer 封装，使用 checkbox 模式支持多选管理
 * @param id - 当前操作对象的唯一标识（如 token id）
 * @param iconClassname - 图标自定义样式
 * @param type - 资产类型 (TOKEN | STOCK)
 */
const PortfolioManageComponent: React.FC<PortfolioManageProps> = ({
  id,
  iconClassname,
  type,
  portfolioId,
  className,
  clickContainerClassName,
}) => {
  // 使用 usePortfolioManage hook 获取所有逻辑和状态
  const { isFavorite, isLoading, handleItemClick, handleStopPropagation } =
    usePortfolioManage({ id, type, portfolioId });

  return (
    <div
      data-openreplay-label="portfolio_portfoliomanage_click"
      onClick={handleStopPropagation}
      className={cn(
        "flex items-center justify-center",
        clickContainerClassName,
        className,
      )}
    >
      {isLoading ? (
        <div className="w-4 h-4 bg-background_white_overlay5 rounded animate-pulse" />
      ) : (
        <div
          data-openreplay-label="portfolio_portfoliomanage_click"
          className={cn(
            "flex items-center justify-center cursor-pointer w-fit h-fit",
            clickContainerClassName,
          )}
          onClick={handleItemClick}
        >
          <Icon
            name="start-fill"
            className={cn(
              "cursor-pointer text-content_quaternary text-4",
              iconClassname,
            )}
            color={
              isFavorite
                ? ospThemes.colors.background_accent4_overlay100
                : ospThemes.colors.content_quaternary
            }
          />
        </div>
      )}
    </div>
  );
};

// 使用 React.memo 优化性能，仅在 id 变化时重新渲染
export const PortfolioManage = React.memo(PortfolioManageComponent);
